"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../../Button/Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BasicCard = function BasicCard(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    cta = _ref.cta,
    whiteFont = _ref.whiteFont,
    children = _ref.children,
    topText = _ref.topText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card--basic d8-u-relative flex flex-column justify-between height-100%"
  }, children, !children && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, topText && /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(whiteFont ? 'd8-u-color-contrast-lower' : 'd8-u-color-contrast-higher', " text-xs d8-u-text-uppercase")
  }, topText), heading && /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('card--basic__heading', 'd8-u-ls-sm', 'text-md', whiteFont && 'd8-u-color-white')
  }, heading), subheading && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', whiteFont && 'd8-u-color-white')
  }, subheading)), cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: cta.id,
    className: cta.className,
    text: cta.text,
    link: cta.link,
    buttonType: cta.buttonType,
    external: cta.external,
    onClick: cta.onClick,
    icon: cta.icon,
    iconFlip: cta.iconFlip,
    buttonSize: cta.buttonSize
  }))));
};
BasicCard.propTypes = {
  heading: _propTypes["default"].string,
  topText: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  cta: _propTypes["default"].object,
  whiteFont: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = exports["default"] = BasicCard;